/* Garnets Recently Viewed (CRO Wave 3) — localStorage based, client-rendered */
(function () {
  const KEY = 'garnets_recently_viewed_v1';
  const MAX = 12;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function track() {
    const node = document.querySelector('[data-recently-viewed-track]');
    if (!node) return;
    const item = {
      handle: node.dataset.handle,
      id: node.dataset.id,
      title: node.dataset.title,
      url: node.dataset.url,
      image: node.dataset.image,
      price: node.dataset.price,
      ts: Date.now()
    };
    if (!item.handle) return;
    let list = read().filter(function (i) { return i.handle !== item.handle; });
    list.unshift(item);
    if (list.length > MAX) list = list.slice(0, MAX);
    write(list);
  }

  function renderInto(container, opts) {
    const currentHandle = container.dataset.currentHandle || '';
    const limit = parseInt(container.dataset.limit || '8', 10);
    let list = read().filter(function (i) { return i.handle !== currentHandle; }).slice(0, limit);
    if (!list.length) {
      container.closest('[data-recently-viewed-section]')?.setAttribute('hidden', '');
      return;
    }
    container.closest('[data-recently-viewed-section]')?.removeAttribute('hidden');
    container.innerHTML = list.map(function (item) {
      return '<a href="' + item.url + '" class="rv-card">' +
        '<div class="rv-card__media">' +
          (item.image ? '<img src="' + item.image + '" alt="" loading="lazy" width="240" height="240">' : '') +
        '</div>' +
        '<div class="rv-card__body">' +
          '<div class="rv-card__title">' + (item.title || '') + '</div>' +
          '<div class="rv-card__price">' + (item.price || '') + '</div>' +
        '</div>' +
      '</a>';
    }).join('');
  }

  function renderAll() {
    document.querySelectorAll('[data-recently-viewed-grid]').forEach(function (c) { renderInto(c); });
  }

  function init() {
    track();
    renderAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.GarnetsRecentlyViewed = { read: read, render: renderAll };
})();
